<template>
  <div class="customer-type">
    <div class="customer-type-container" v-bind:style="{ 'background-color': type?.type_color?.hex_value }">
      <p class="customer-type-name">{{ type.name }}</p>
      <Transition>
        <span v-if="isAdded" id="is-added" class="customer-type-added">Added!</span>
      </Transition>
      <Transition>
        <span v-if="isUpdated" id="is-updated" class="customer-type-updated">Updated!</span>
      </Transition>
      <div class="customer-type-buttons-container customer-type-buttons-container-desktop">
      <button @click="removeCustomerType" :key="type.id" :id="type.id"  type="submit" name="submit" class="btn btn--warning">
        Remove
      </button>
      <button @click="editCustomerType(type)" type="submit" name="submit" class="btn btn--primary">
        Edit
      </button>
    </div>
    </div>
    <div class="customer-type-buttons-container customer-type-buttons-container-mobile">
      <button @click="removeCustomerType" :key="type.id" :id="type.id"  type="submit" name="submit" class="btn btn--warning">
        Remove
      </button>
      <button @click="editCustomerType(type)" type="submit" name="submit" class="btn btn--primary">
        Edit
      </button>
    </div>
  </div>
  <div class="subtypes">
    <CustomerSubType v-for="(subType, index) in type.sub_types" :key="subType.id" :data-id="subType.id" :data-counter="index"
      :subtype="subType"
      :added="addedSubTypeId === subType.id"
      :updated="editedSubTypeId === subType.id"
      @customerSubTypeDeleted="deleteSubType"
      @customerSubTypeEditingEnabled="editSubType"
    />
  </div>
</template>

<script>
import api from '../../api'
import CustomerSubType from './CustomerSubType.vue';
export default {
  name: 'CustomerType',
  components: { CustomerSubType },
  emits: ['customerTypeDeleted', 'customerTypeEditingEnabled', 'customerSubTypeEditingEnabled'],
  props: {
    type: {
      type: Object,
      default: null
    },
    added: {
      type: Boolean,
      default: false,
    },
    addedSubTypeId: {
      type: Number,
      default: null,
    },
    editedSubTypeId: {
      type: Number,
      default: null,
    },
    updated: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isAdded: this.$props.added,
      isUpdated: this.$props.updated,
    }
  },
  methods: {
    editSubType(subType) {
      this.$emit('customerSubTypeEditingEnabled', subType);
    },
    deleteSubType() {
      this.$emit('customerSubTypeDeleted');
    },
    removeCustomerType(e) {
      e.preventDefault()
      let params = { id: e.target.id }
      api.deleteCustomerType(params).then(res => {
        console.log(res);
        this.$emit('customerTypeDeleted');
      })
    },
    editCustomerType(type) {
      this.$emit('customerTypeEditingEnabled', type);
    },
    changer() {
      setTimeout(() => {
        if (this.isMobile()) {
          if (document.getElementById("is-updated")) {
            document.getElementById("is-updated").remove();
          }
          if (document.getElementById("is-added")) {
            document.getElementById("is-added").remove();
          }
        } else {
          this.isAdded = false;
          this.isUpdated = false;
        }
      }, 2000);
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  beforeMount() {
    this.changer()
  },
  mounted() {
    this.$el.scrollRight += 600
  }
}
</script>
<style scoped>
.customer-type {
  display: flex;
  align-items: center;
}

.customer-type-name {
  min-width: 100px;
}

.customer-type-container {
  display: flex;
  align-items: center;
  padding: 5px;
  justify-content: space-between;
}

.customer-type-added,
.customer-type-updated {
  color: #089E56;
}

.customer-type-buttons-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.customer-type-container {
  margin-top: 0.4375rem;
  border: 1px solid #E5E5E5;
  position: relative;
  background: white;
  padding-left: 15px;
  min-width: 100%;
}
.btn {
  min-width: 100px;
  max-width: 110px;
  max-height: 40px;
  margin: 0 5px;
  border: none;
}

.customer-type-buttons-container-mobile {
  display: none;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

@media screen and (max-width: 992px) {
  .customer-type {
    overflow: scroll;
  }

  .customer-type-container {
    padding: 0 10px 0 10px;
    display: flex;
    align-items: center;
  }
  .customer-type-buttons-container-mobile {
    display: flex;
  }

  .customer-type-buttons-container-desktop {
    display: none;
  }
}
</style>
